import MovimientoCreate from './MovimientoCreate'
export {MovimientoCreate}
export default MovimientoCreate
